import { queryOptions } from '@tanstack/react-query';

import ModificationService from './modificationService';

// **** Queries **** //

export const getModificationQueryOptions = {
  modifications: () =>
    queryOptions({
      queryKey: ['modifications'] as const,
      queryFn: ({ signal }) => ModificationService.getModifications({ signal }),
    }),
  taskModificationConfigTableData: () =>
    queryOptions({
      queryKey: ['modifications', 'withRegionsAndTasks'] as const,
      queryFn: () => ModificationService.getModificationWithRegionsAndTasksDTOList(),
    }),
};

// **** Mutations **** //

export const getModificationMutationOptions = {
  createOrUpdate: () => ({
    mutationFn: ModificationService.createOrUpdateModifications,
    meta: {
      invalidates: [getModificationQueryOptions.taskModificationConfigTableData().queryKey],
      successMessage: 'Saved modification successfully',
    },
  }),
  delete: () => ({
    mutationFn: ModificationService.deleteModification,
    meta: {
      invalidates: [getModificationQueryOptions.taskModificationConfigTableData().queryKey],
      successMessage: 'Deleted modification successfully',
    },
  }),
};
